<template>
  <div class="page-section">
    <!-- .section-block -->
    <div class="section-block">
      <ul class="timeline">
        <!-- .timeline-item -->
        <li class="timeline-item" v-for="(item,i) in activities">
          <!-- .timeline-figure -->
          <div class="timeline-figure">
            <span class="tile tile-circle tile-sm"><em class="far fa-calendar-alt fa-lg"></em></span>
          </div><!-- /.timeline-figure -->
          <!-- .timeline-body -->
          <div class="timeline-body">
            <!-- .media -->
            <div class="media">
              <!-- .media-body -->
              <div class="media-body">
                <h6 class="timeline-heading">
                  <a href="#" class="text-link">{{item.module}}</a>
                </h6>
                <p class="mb-0">
                 {{item.activity}}
                </p>
                <p class="timeline-date d-sm-none"> About a minute ago </p>
              </div><!-- /.media-body -->
              <!-- .media-right -->
              <div class="d-none d-sm-block">
                <span class="timeline-date">{{item.log_timestamp}}</span>
              </div><!-- /.media-right -->
            </div><!-- /.media -->
          </div><!-- /.timeline-body -->
        </li>
      </ul><!-- .timeline -->
    </div><!-- /.section-block -->
    <div class="text-center">
      <div class="spinner-border text-primary" role="status" v-show="!showButtonMore">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <p class="text-center" v-show="showButtonMore">
      <button type="button" class="btn btn-light" @click="loadMore"><em class="fa fa-fw fa-angle-double-down"></em> Load more</button>
    </p>
  </div>
</template>

<script>
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";

export default {
  name: "EmployeeActivities",
  props:{
    tabs:{
      type:String
    }
  },
  watch:{
    tabs(){
      if(this.tabs === 'activities'){
        this.getActivities()
      }
    }
  },
  data(){
    return {
      activities:[],
      limit:10,
      offset:1,
      showButtonMore:true
    }
  },
  methods:{
    getActivities(){
      this.showButtonMore = false
      let payload = {
        emp_id:this.$store.getters.empId,
        limit:this.limit,
        offset:this.offset
      }
      AxiosCall.Get(payload, urlApi.employee.activities).then(res=>{
        if(res.success){
          this.showButtonMore = true
          if(res.atributes.length  === 0 ) this.showButtonMore = false
          for (let data of res.atributes){
            this.activities.push(data)
          }
        }else {
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    loadMore(){
      this.offset = this.offset + 1
      this.getActivities()
    }
  }
}
</script>